export default "__VITE_ASSET__BTKVo44c__"